// For consistency when setting and checking cookies, we define the prompt keys.
export const PROMPTS = {
  kioskSignIn: 'kioskSignInPrompt',
  linkBank: 'linkBankPrompt',
  signIn: 'janeSignInPrompt',
};

export type PromptsType = (typeof PROMPTS)[keyof typeof PROMPTS];
